var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.7,
    height: 19.7,
    viewBox: "0 0 19.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8276",
    "data-name": "\\uADF8\\uB8F9 8276",
    transform: "translate(-671.646 -382.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8275",
    "data-name": "\\uADF8\\uB8F9 8275",
    transform: "translate(-14 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7867",
    "data-name": "\\uADF8\\uB8F9 7867",
    transform: "translate(15.5 -1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_62",
    "data-name": "\\uC120 62",
    x2: 18.993,
    y2: 18.993,
    transform: "translate(670.5 378.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36933",
    "data-name": "\\uD328\\uC2A4 36933",
    d: "M18.993,0,8.9,10.09,0,18.993",
    transform: "translate(670.5 378.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.ead8655882e7dbfe8c50085093b24d0b.svg";
export { ForwardRef as ReactComponent };